module.exports = __webpack_public_path__ + "media/components/assets/ventilator_01-e0f4e7f8aeb77408b4210e4c3d6142d5.jpg";